import { createIcon } from '@chakra-ui/react';

export const UserIcon = createIcon({
  displayName: 'UserIcon',
  viewBox: '0 0 17 21',
  path: [
    <path
      key="1"
      opacity="1"
      d="M16.8627 16.9C16.5127 14.85 14.4127 13.8 12.7127 13.05C11.9627 12.7 10.9127 12.3 10.6127 11.4C10.4127 10.9 10.5127 10.4 10.7627 9.95C11.2127 9.5 11.6127 9.1 11.9627 8.55C12.0627 8.4 12.1127 8.3 12.2127 8.15C13.2127 6.7 13.3627 4.7 12.7627 3.05C12.1627 1.25 10.5627 0.05 8.61267 0H8.31267C6.36267 0.05 4.76267 1.25 4.16267 3.05C3.56267 4.75 3.71267 6.7 4.71267 8.15C4.76267 8.3 4.86267 8.4 4.96267 8.55C5.31267 9.1 5.76267 9.5 6.16267 9.95C6.36267 10.4 6.46267 10.9 6.31267 11.4C6.01267 12.3 4.96267 12.7 4.21267 13.05C2.51267 13.8 0.412671 14.85 0.0626715 16.9C-0.287329 18.6 0.862672 20.3 2.66267 20.3H14.4627C16.0627 20.3 17.2127 18.6 16.8627 16.9Z"
      fill="#AAAAAA"
    />
  ]
});
